import { render, staticRenderFns } from "./EModalInfo.vue?vue&type=template&id=136f38f9"
import script from "./EModalInfo.vue?vue&type=script&lang=js"
export * from "./EModalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports